import type { ReactNode } from 'react'

export type SectionCardRadius = 'md' | 'lg'

export type SectionCardContentLayout = 'row' | 'column'

export type SectionCardPreviewState =
  | 'default'
  | 'with-link'
  | 'with-header-actions'
  | 'with-metrics'

export const SECTION_CARD_PREVIEW_STATES: SectionCardPreviewState[] = [
  'default',
  'with-link',
  'with-header-actions',
  'with-metrics',
]

export const SECTION_CARD_PREVIEW_STATE_LABELS: Record<
  SectionCardPreviewState,
  string
> = {
  default: 'Default',
  'with-link': 'With title link',
  'with-header-actions': 'With header actions',
  'with-metrics': 'With metric cards',
}

export const SECTION_CARD_DEMO_TITLE = 'Collections'

export type SectionCardProps = {
  children?: ReactNode
  title?: string
  /** When set, title becomes a link (native anchor). */
  titleHref?: string
  showTitleChevron?: boolean
  headerAfterTitle?: ReactNode
  headerRight?: ReactNode
  /** `lg` = 16px (dashboard sections), `md` = 12px (report chart panels). */
  radius?: SectionCardRadius
  /** Body flex direction. Defaults to `column`. */
  contentLayout?: SectionCardContentLayout
  className?: string
  /** Dark surface styling (aligned with SelectionBox / SelectableCard). */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: SectionCardPreviewState
}
